








































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCambioServicio } from './fetchCambioServicio';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import moment from 'moment';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class reemplazaEquipo extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) envio_tecnico: any;
  @Prop({ default: null }) titulo: any;
  @Prop({ default: null }) serienumero!: any;
  @Prop({ default: null }) tipoeqid!: any;
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify;
  model_serienumero: any = null;
  model_tipoeqname: any = null;
  lista_tipoeqname: any = null;
  detalle: boolean = false;

  formFields: FormFieldDefMap = {
    model_serienumero_new: {
      label: 'Serie Número*',
      id: '',
      value: '',
    },
    model_tipoeqname_new: {
      label: 'Tipo de Equipo',
      id: '',
      value: '',
    },
    serie_activa_numero_new: {
      label: 'Serie Activa Número',
      id: '',
      value: '',
    },
    serie_activa_modalidad_new: {
      label: 'Modalidad',
      id: '',
      value: '',
    },
    serie_activa_plataforma_new: {
      label: 'Plataforma',
      id: '',
      value: '',
    },
    serieactivaplata_ingresada_new: {
      label: 'Ingresada en Plataforma',
      id: '',
      value: '',
    },
    serieactivaplata_fecha_new: {
      label: 'Fecha en Plataforma',
      id: '',
      value: '',
    },
    serieactivaid_dispositivo_new: {
      label: 'ID de dispositivo',
      id: '',
      value: '',
    },
    serieactivaepc_new: {
      label: 'EPC',
      id: '',
      value: '',
    },
    sim_serie_numero_new: {
      label: 'Sim Serie Número',
      id: '',
      value: '',
    },
    sim_estado_new: {
      label: 'Sim Estado',
      id: '',
      value: '',
    },
    patente_new: {
      label: 'Patente Vehículo',
      id: '',
      value: '',
    },
    clienterut_new: {
      label: 'RUT Cliente',
      id: '',
      value: '',
    },
    clienteid_new: {
      label: 'ID Cliente',
      id: '',
      value: '',
    },
    nombre_new: {
      label: 'Cliente',
      id: '',
      value: '',
    },
    serieactivafecha_baja_new: {
      label: 'Fecha de Baja',
      id: '',
      value: '',
    },
    serieactivaobs_new: {
      label: 'Observación',
      id: '',
      value: '',
    },
    nombre_flota: {
      label: 'Flota',
      id: '',
      value: '',
    },
  };

  async get_equipo_activa() {
    this.loadingService.showLoading();
    let self = this;
    return fetchCambioServicio(
      {
        serienumero: this.formFields.model_serienumero_new.value,
        tipoedid: this.formFields.model_tipoeqname_new.value,
        tecnicoid: this.envio_tecnico,
        editando: this.editando,
        reemplazo: 'reemplazo',
      },
      'conectaCambioServicio/get_equipo_activa_asignado'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          self.formFields.serie_activa_numero_new.value =
            data.data.LISTA[0]['serieactivanro'];

          self.formFields.serie_activa_modalidad_new.value =
            data.data.LISTA[0]['serieactivamodalidad'];

          self.formFields.serie_activa_plataforma_new.value =
            data.data.LISTA[0]['serieactivaplataforma'];

          if (data.data.LISTA[0]['serieactivaplata_ingresada'] == 'S') {
            self.formFields.serieactivaplata_ingresada_new.value =
              data.data.LISTA[0]['serieactivaplata_ingresada'];
          } else {
            self.formFields.serieactivaplata_ingresada_new.value = '';
          }
          self.formFields.serieactivaplata_fecha_new.value = moment(
            data.data.LISTA[0]['serieactivaplata_fecha']
          ).format('YYYY/MM/DD HH:mm:ss');
          self.formFields.serieactivaid_dispositivo_new.value =
            data.data.LISTA[0]['serieactivaid_dispositivo'];
          self.formFields.nombre_flota.value =
            data.data.LISTA[0]['nombre_flota'];
          self.formFields.serieactivaepc_new.value =
            data.data.LISTA[0]['serieactivaepc'];
          self.formFields.sim_serie_numero_new.value =
            data.data.LISTA[0]['simserienumero'];
          self.formFields.patente_new.value =
            data.data.LISTA[0]['patente_vehiculo'];
          self.formFields.sim_estado_new.value =
            data.data.LISTA[0]['simestado'];
          self.formFields.clienterut_new.value = data.data.LISTA[0]['rut_ve'];
          self.formFields.nombre_new.value =
            data.data.LISTA[0]['nombre_cliente'];
          self.formFields.clienteid_new.value = data.data.LISTA[0]['clienteid'];
          self.formFields.serieactivafecha_baja_new.value = moment(
            data.data.LISTA[0]['serieactivafecha_baja']
          ).format('DD/MM/YYYY HH:mm:ss');

          self.formFields.serieactivaobs_new.value =
            data.data.LISTA[0]['serieactivaobs'];

          if (this.accion_modal == 'EDITAR') {
            self.formFields.model_tipoeqname_new.value =
              data.data.LISTA[0]['nombre_equipo'];
          }
        } else {
          this.loadingService.hideLoading();
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        return null;
      })

      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async buscar_serie_numero() {
    //MicroServicios/catalogo/conectaCambioServicio.py
    this.loadingService.showLoading();
    return fetchCambioServicio(
      { numero_serie: this.formFields.model_serienumero_new.value },
      'conectaCambioServicio/buscar_equipo_por_serie'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          this.lista_tipoeqname = data.data.LISTA;
        } else {
          this.loadingService.hideLoading();
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  } //end buscar_serie_numero
  @Watch('formFields')
  onModelTipoCambioChanged(val: any, oldVal: any) {
    this.$emit('input', this.formFields);
  }
  editando: any;
  mounted() {
    if (this.accion_modal == 'EDITAR') {
      this.detalle = true;
      this.formFields.model_serienumero_new.value = this.serienumero;
      this.formFields.model_tipoeqname_new.value = this.tipoeqid;
      this.editando = 'Editar';
      this.get_equipo_activa();
    }
  }

  @Watch('serienumero')
  onSerienumeroChanged(newValue: any) {
    this.formFields.model_serienumero_new.value = newValue;
  }

  @Watch('tipoeqid')
  onTipoeqidChanged(newValue: any) {
    this.formFields.model_tipoeqname_new.value = newValue;
  }
} //end class
